import BackgroundImage from 'components/ReusableComponents/BackgroundImage'
import FileIcon from 'components/ReusableComponents/FileIcon'
import {
  viewableFileExtensions,
  viewableImgExtensions,
  viewableVideoExtensions
} from 'features/Messaging/fileUploadConfig'
import { isURIencoded } from 'utils/helpers'

import styles from './ConversationBubble.module.scss'

const FilePreview = ({
  extension,
  onClick,
  src,
  clickable = true,
  className,
  showFileName = false
}) => {
  const fileName = src.match(/[^/\\&?]+\.\w{3,4}(?=([?&].*$|$))/)?.[0]

  const shortFileName = fileName?.replace(/\d{14}__swaypay__/, '')

  let type

  const encodedSrc = isURIencoded(src) ? src : encodeURI(src)

  if (viewableImgExtensions.includes(extension)) {
    type = 'image'
  }

  if (viewableFileExtensions.includes(extension)) {
    type = 'downloadable'
  }

  if (viewableVideoExtensions.includes(extension)) {
    type = 'video'
  }

  if (type === 'image') {
    return (
      <div
        className={className || styles.mediaImg}
        style={{ cursor: clickable ? 'pointer' : 'default' }}
      >
        <BackgroundImage
          src={encodedSrc}
          className={styles.mediaImgInner}
          onClick={clickable ? onClick : null}
        />
      </div>
    )
  }

  if (type === 'downloadable') {
    return (
      <div
        className={className || styles.mediaDownloadable}
        style={{ cursor: clickable ? 'pointer' : 'default' }}
      >
        {clickable ? (
          <a href={encodedSrc} target="_blank" rel="noreferrer" download={`file`}>
            <FileIcon extension={extension} />
            {showFileName && (
              <p className={styles.fileName} title={fileName}>
                {shortFileName || fileName}
              </p>
            )}
            {clickable && <div className={styles.downloadHover} />}
          </a>
        ) : (
          <>
            <FileIcon extension={extension} />
            {showFileName && (
              <p className={styles.fileName} title={fileName}>
                {shortFileName || fileName}
              </p>
            )}
          </>
        )}
      </div>
    )
  }

  if (type === 'video') {
    return (
      <div
        className={className || styles.mediaDownloadable}
        style={{ cursor: clickable ? 'pointer' : 'default' }}
        onClick={clickable ? onClick : null}
      >
        <FileIcon extension={extension} />
        {showFileName && (
          <p className={styles.fileName} title={fileName}>
            {shortFileName || fileName}
          </p>
        )}
        {clickable && <div className={styles.playHover} />}
      </div>
    )
  }

  return null
}

export default FilePreview
